<template>
    <div>
        <div ref="container" :class="{'overflow-hidden max-h-200': !expanded}">
            <iframe :src="block.data.url + '?embed=1&dark=' + isDark()" scrolling="no"
                    style="overflow: hidden; border: medium none; min-width: 320px; " width="100%" height=""
                    @load="checkTelegramHeight"
                    frameborder="0"></iframe>
        </div>
        <div v-if="!loading && !expanded" @click="expanded = true" class="flex justify-center p-3"
            :class="{'hidden': loading}"
        >
            <div class="mx-auto w-full max-w-sm mt-4 cursor-pointer text-sm btn bg-gray-200 text-gray-900 dark:text-white dark:bg-slate-600 btn-md">
                Развернуть
            </div>
        </div>
    </div>
</template>
<script>
import DarkTheme from "../../js/modules/DarkTheme";

export default {
    props: ['block', 'view'],
    data() {
        return {
            loading: true,
            expanded: !!this.view,
        };
    },
    methods: {
        checkTelegramHeight(e) {
            if (!this.expanded) {
                setTimeout(() => {
                    this.loading = false;
                    let contHeight = this.$refs.container.clientHeight;
                    let iframeHeight = e.target.clientHeight;

                    if (iframeHeight <= contHeight) {
                        this.expanded = true;
                    }
                }, 200);
            }
        },
        isDark() {
            return DarkTheme.isDark() ? 1 : 0;
        }
    }
}
</script>